/**
 * Compares 2 dates checking if they represent same day
 * @param  {Date}    a
 * @param  {Date}    b
 * @return {boolean}   True if same, if any is not defined then false
 */
export function isSameDay(a: Date | undefined, b: Date | undefined): boolean {
    return !!(
        a &&
        b &&
        a.getFullYear() === b.getFullYear() &&
        a.getDate() === b.getDate() &&
        a.getMonth() === b.getMonth()
    );
}
